import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import TrackerToastContent from '../TrackerToastContent';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { useEffect, useState } from 'react';

const formatTimestamp = (value) => {
  if (!value) return '';
  const date =
    typeof value === 'number'
      ? new Date(value)
      : value.toDate
        ? value.toDate()
        : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
};

function DiceHistoryModal({ visible, onClose, rolls = [], mode = 'dark' }) {
  const isDark = mode !== 'light';
  const [isPhone, setIsPhone] = useState(false);

  const renderResult = (roll) => {
    if (roll?.kind === 'tracker' && roll?.tracker) {
      return (
        <TrackerToastContent
          tracker={roll.tracker}
          changeInfo={roll.changeInfo || null}
          variant='announcement'
          mode={mode}
        />
      );
    }

    return roll?.displayText || roll?.command || '';
  };

  useEffect(() => {
    const mediaQueryWidth = window.matchMedia('(max-width: 620px)');
    const handleMediaChange = () => {
      setIsPhone(mediaQueryWidth.matches);
    };
    handleMediaChange();
    mediaQueryWidth.addListener(handleMediaChange);
    return () => {
      mediaQueryWidth.removeListener(handleMediaChange);
    };
  }, []);

  const items = Array.isArray(rolls)
    ? [...rolls].sort(
        (a, b) => (b.clientCreatedAt ?? 0) - (a.clientCreatedAt ?? 0),
      )
    : [];

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onClose}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: isDark ? '2px solid var(--onyx)' : '2px solid #e4E7C5',
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: isPhone ? 'calc(100% - 34px)' : 600,
        height: isPhone ? 'calc(100% - 114px)' : 520,
        marginTop: isPhone ? '80px' : '',
      }}
    >
      <div
        className={`trialment_login_form ${isDark ? 'df_modal_form_dark' : ''}`}
        style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <div
          className='trialment_login_form_row'
          style={{ fontWeight: 700, fontSize: 16, marginBottom: 6, textAlign: 'center' }}
        >
          Dice History
        </div>
        <div
          style={{
            flex: 1,
            overflow: 'auto',
            border: isDark ? '1px solid var(--onyx)' : '1px solid #dcdcdc',
            borderRadius: '6px',
          }}
        >
          {items.length === 0 ? (
            <div style={{ padding: '12px' }}>No rolls or tracker events yet.</div>
          ) : (
            <table
              className='orchestrator_table'
              style={{ width: '100%', borderCollapse: 'collapse' }}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '8px' }}>Player</th>
                  <th style={{ textAlign: 'left', padding: '8px' }}>Result</th>
                  <th
                    style={{
                      textAlign: 'left',
                      padding: '8px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    When
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((roll) => (
                  <tr key={roll.id}>
                    <td
                      style={{
                        padding: '8px',
                        borderTop: isDark
                          ? '1px solid var(--onyx)'
                          : '1px solid #e4e4e4',
                      }}
                    >
                      {roll.username || 'Player'}
                    </td>
                    <td
                      style={{
                        padding: '8px',
                        borderTop: isDark
                          ? '1px solid var(--onyx)'
                          : '1px solid #e4e4e4',
                      }}
                    >
                      {renderResult(roll)}
                    </td>
                    <td
                      style={{
                        padding: '8px',
                        borderTop: isDark
                          ? '1px solid var(--onyx)'
                          : '1px solid #e4e4e4',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {formatTimestamp(roll.clientCreatedAt || roll.createdAt)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        >
          <Button
            label='Close'
            type={isDark ? 'onyx' : 'black-white'}
            onPress={onClose}
          />
        </div>
      </div>
    </Rodal>
  );
}

export default DiceHistoryModal;
